import React from 'react';

import { Tag } from '@/js/libs/ui/src/V2';

import type { ColumnProps } from '../../types';

export const LabelsCell: React.FC<ColumnProps> = React.memo(function LabelsCell({ item }) {
  if (!item.labels.length) {
    return null;
  }

  return (
    <Tag.Group>
      {item.labels.map((label) => (
        <Tag key={label.id?.toString()} title={label.name} />
      ))}
    </Tag.Group>
  );
});
